import { render, staticRenderFns } from "./Event-User-List.vue?vue&type=template&id=44e8eed7&"
import script from "./Event-User-List.vue?vue&type=script&lang=js&"
export * from "./Event-User-List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports